<span [ngClass]="this.classAvatar">
    {{initial}}
    <i *ngIf="this.icon" class="np" [ngClass]="[this.icon]"></i>
</span>